import { render } from "./editFunc.vue?vue&type=template&id=311d8aa8"
import script from "./editFunc.vue?vue&type=script&lang=js"
export * from "./editFunc.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__